import React, {useState, useEffect, useRef} from "react";
// import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { useParams } from "react-router-dom";
import {Card, CardBody, CardHeader} from "../../../../_metronic/_partials/controls";
import {PaginationTable} from "../../../components/PaginationTable/PaginationTable";
import {useSelector} from "react-redux";
import axios from "axios";
import {headerSortingClasses, sortCaret} from "../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { updateStatus, getSupplierOrderInfo, getOrdersSupplierTenantPagination } from "./ordersCrud";
import OrderDetails from "./OrderDetails";

function OrdersPage(props) {

    const { status } = props
    const { orderId } = useParams(); // Get orderId from URL params
    const [isInvoiceClicked, setIsInvoiceClicked] = useState(false)
    const [isOrderDetails, setIsOrderDetails] = useState(false)
    const [invoiceDetails, setInvoiceDetails] = useState({})

    const initialRender = useRef(true);

    const {user,accessToken} = useSelector (
        ({auth}) =>({
            user: auth.user != null ? auth.user : null,
            accessToken: auth.authToken,
        })
    )

    const initialData = {
        data: [],
        totalCount: 0,
        pageSize:5
    }

    const [data,setData] = useState(initialData)

    const initialOrder = {
        _id:"",
        createdDate:"",
        submissionDate: new Date(),
        orderNumber:"",
        status:"",
        products:[],
        location:[],
        company:[],
        totalCost: 0,
        totalProductQty: 0,
        processedDate: new Date(),
        inTransitDate: new Date(),
        deliveredDate: new Date()
    }
    const [order,setOrder] = useState(initialOrder)
    const [isOrderFound, setIsOrderFound] = useState(false)
    const [page,setPage] = useState(1)

    const fetchOrder = async (pathId) => {
        console.log(pathId)
        await getSupplierOrderInfo(accessToken, pathId, user.id).then(order => {
            console.log("~~~~~~~Order: ", order)
            if(typeof(order.data) !== 'undefined' && order.data !== null) {
                setOrder(order.data)
                setIsOrderFound(true)
            }
            setIsOrderDetails(true)
        }).catch(error => console.log(error))
    }

    useEffect(() => {
        console.log("~~~~~~~OrderId from URL: ", orderId)
        if(typeof(orderId) !== 'undefined' && orderId !== ''){
            fetchOrder(orderId)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[orderId])

    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            fetchOrders(initialFilter)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.status])

    const fetchOrders = (queryParams) => {
        getOrdersSupplierTenantPagination(accessToken, queryParams).then(response => {
            console.log("Response: ", response.data.data)
            const data = {
                data : response.data.data,
                totalCount : response.data.totalCount,
                pageSize : response.data.pageSize
            }
            setData(data)
        }).catch(error => console.log(error))
    }

    const setStatus = (orderId,status) => {

        console.log("Setting Status",orderId,status)

        updateStatus(user.id, accessToken,orderId, status).then(response  =>{

        })
    }

    const setProcessed = (id) => {
        setStatus(id,"Processed");
        window.location.reload()
    }

    const setInTransit = (id) => {
        setStatus(id,"In Transit")
        window.location.reload()
    }

    const setDelivered = (id) => {
        setStatus(id,"Delivered")
        window.location.reload()
    }


    const columns = [
        {
            dataField: "orderNumber",
            text: "Order Number",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.OrderNumberFormatter,
            // events: {
            //     onClick: (e, column, columnIndex, row, rowIndex) => {
            //         setInvoiceDetails(row)
            //         setIsInvoiceClicked(true)
            //     }
            // },
        },
        {
            dataField: "submissionDateISO",
            text: "Submission Date",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "companyName",
            text: "Client",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.CompanyFormatter
            
        },
        {
            dataField: "supplier",
            text: "Supplier",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.SupplierFormatter
        },
        {
            dataField: "totalCost",
            text: "Total Cost",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.TotalCostFormatter
        },
        {
            dataField: "totalProductQty",
            text: "Total Product Quantity",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.TotalProductFormatter
        },
        {
            dataField: "status",
            text: "Order Status",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.StatusFormatter
        },
        {
            dataField: "viewDetails",
            text: "View Details",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.ViewDetailsFormatter,
            formatExtraData:{
                viewDetails: setOrder,
                setIsOrderDetails: setIsOrderDetails,
                setIsOrderFound: setIsOrderFound
            }
        },
    ];

    const sizePerPageList = [
        {text: "10", value: 10},
        {text: "20", value: 20},
        {text: "50", value: 50}
    ]

    const initialFilter = {
        filter: {
            status: status ? status : "",
            searchText:"",
        },
        sortOrder: "desc",
        sortField: "submissionDateISO",
        pageNumber: 1,
        pageSize: 10
    }

    const sorting = [{dataField: "submissionDateISO",order:"desc"}]
    const pagination = {custom: true, sizePerPageList: sizePerPageList}
    const tableClasses = "table table-head-custom table-head-bg table-borderless table-vertical-center table-padding-2"

    const prepareFilter = (queryParams,values) => {
        const {searchText} = values;
        const newQueryParams = {...queryParams};
        const filter = {};

        filter.searchText = searchText ?? "";
        filter.status = status ? status : "";

        newQueryParams.filter = filter;
        return newQueryParams;
    }

    return (
        <>
            { !isOrderDetails ? (
                    <Card>
                        <CardHeader title="All Orders">
                        </CardHeader>
                        <CardBody>
                            <PaginationTable
                                data={data}
                                columns={columns}
                                pagination={pagination}
                                isLoading={false}
                                sorting={sorting}
                                tableClasses={tableClasses}
                                fetcher={fetchOrders}
                                filterFunction={prepareFilter}
                                initialFilter={initialFilter}
                            />
                        </CardBody>
                    </Card>
                )
                :
                (   isOrderFound ?
                        <>
                            <OrderDetails order={order} setOrder={setOrder} setIsOrderDetails={setIsOrderDetails} isOrderDetails={isOrderDetails} />
                        </>
                    :
                        <div className="card card-custom gutter-b">
                            <div className="card-body p-0">
                                <div className="row justify-content-center px-8 py-md-27 px-md-0">
                                    <div className="col-md-10">
                                        <div className="col-sm bg-light-primary px-6 py-4 rounded-xl mr-7">
                                            <div className="text-center mb-4">
                                                <span className="card-label font-weight-bolder text-dark text-center font-size-lg">Order Not Found</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                )}
        </>
    );
}
    
export default injectIntl(OrdersPage);